import { Typography } from '@mui/material'

function Section(_props) {
  const { title = null, children } = _props

  return (
    <section className="my-8">
      {title && (
        <Typography variant="h2" component="h2" className="mb-8">
          {title}
        </Typography>
      )}
      {children}
    </section>
  )
}



export default Section
